import { render } from "./ContenutoReso.vue?vue&type=template&id=5d3c1767"
import script from "./ContenutoReso.vue?vue&type=script&lang=js"
export * from "./ContenutoReso.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__